import React, { Component } from 'react';
import Skeleton from 'react-loading-skeleton';
import { withNamespaces } from 'react-i18next';
import { AiFillPlusCircle, AiFillMinusCircle } from 'react-icons/ai';
import DatePicker from "react-datepicker";
// import BootstrapTable from "react-bootstrap-table-next";
// import { Popover, OverlayTrigger } from "react-bootstrap";
// import { Icon } from "@iconify/react";

import DatePickerContainer from "../../components/DatePicker/DatePickerContainer";
import DataTable from '../../components/Datatable/DataTable';
import Auxiliary from '../../hoc/Auxiliary/Auxiliary';
import StringInput from '../../components/Input/StringInput/StringInput';
// import DateTimePicker from '../../components/DateTimePicker/DateTimePicker';
import Button from '../../components/Button/Button';
import NumberInput from '../../components/Input/NumberInput/NumberInput';
import { formValidation } from '../../hoc/Shared/utility';
import ValidationError from '../../components/ValidationError/ValidationError';

class AgentPayoutListing extends Component
 {
    /* ============ component lifecycle [START] ============ */
    constructor(props) 
    {
        super(props);
        this.state = 
        {
            showCard: false,
        };
        // console.log('constructor (listing):', this.state);
    }

    componentDidMount() 
    {
        formValidation('agent_payout_form');
    }
    /* ============ component lifecycle [END] ============ */

    /* ============ function [START] ============ */
    footerFormatter(column, colIndex, { text }) 
    {
        return (
            <div>
                {/* <p className='sub-total'>{column["footer"][0]}</p> */}
                <p>( {column["footer"][0]} )</p>
            </div>
        );
    }

    toggleCard = () => 
    {
        this.setState({
            showCard: !this.state.showCard,
        });
    };
    /* ============ function [END] ============ */
    
    render() 
    {
        const { t } = this.props;
        let permission = this.props.currentUser.permission ? this.props.currentUser.permission : [];
        const num_format = { maximumFractionDigits: 2, minimumFractionDigits: 2 };
        
        const columns =
        [
            {
                text: '',
                dataField: 'action',
                headerStyle: { width: '120.5px' },
                headerFormatter: (column, colIndex) => 
                {
                    let val = permission.includes('agent_payout_submit') ? (
                        <input
                            type='checkbox'
                            id='check_all'
                            name='check_all'
                            onChange={(event) => this.props.checkAllHandler(event, this.props.tabName, 'formInput')}
                            checked={this.props.checkAll ? true : false}
                        />
                    ) : (
                        ''
                    );
                    return val;
                },
                formatter: (cell, row, rowIndex, extraData) => 
                {
                    let val = permission.includes('agent_payout_submit') ? (
                        (Number(row.payout_base_currency) !== 0) ? (
                            <input
                                type='checkbox'
                                className='editor-active'
                                id={`cb_${row.aid}`}
                                name={`cb_${row.aid}`}
                                checked={extraData[`cb_${row.aid}`] ? true : false}
                                onChange={(event) => this.props.onInputChange(event, this.props.tabName, 'formInput')}
                            />
                        ) : (
                            ''
                        )
                    ) : (
                        ''
                    );

                    return val;
                },
                formatExtraData: this.props.data.formInput,
            },
            {
                text: t('global.no'),
                dataField: 'no',
                formatter: (cell, row, rowIndex) => 
                {
                    let rowNumber = rowIndex + 1;
                    return <span>{rowNumber}</span>;
                },
                headerStyle: () => 
                {
                    return { width: '120px' };
                },
            },
            {
                text: t('agent-payout.agent'),
                dataField: 'agent',
                sort: true,
                onSort: (field, order) => this.props.onSort(field, order, this.props.tabName),
                headerStyle: () => 
                {
                    return { width: '150px' };
                },
            },
            // {
            //     text: t('agent-payout.game-type'),
            //     dataField: 'slug',
            //     formatter: (cell, row, rowIndex) => 
            //     {
            //         return '-';
            //     },
            //     headerStyle: () => 
            //     {
            //         return { width: '150px' };
            //     },
            // },
            {
                text: t('agent-payout.share-percentage'),
                dataField: 'percentage',
                formatter: (cell, row, rowIndex) => 
                {
                    return <span>{row.percentage}%</span>;
                },
                headerStyle: () => 
                {
                    return { width: '150px' };
                },
            },
            {
                text: t('agent-payout.active-member'),
                dataField: 'total_member',
                formatter: (cell, row, rowIndex) => 
                {
                    return <span>{row.total_member}</span>;
                },
                headerStyle: () => 
                {
                    return { width: '150px' };
                },
            },
            {
                text: `${t('agent-payout.win-lose')} (${t('global.currency.usd')})`,
                dataField: 'win_lose',
                sort: true,
                onSort: (field, order) => this.props.onSort(field, order, this.props.tabName),
                formatter: (cell, row, rowIndex) => 
                {
                    let val = permission.includes(
                        'agent_payout_details'
                    ) ? (
                        <b>
                            <a href='/#' onClick={(event) => this.props.betDetailsHandler(event, row.aid, this.props.data.filterInput.confirm_date, null)}>
                                {new Intl.NumberFormat('en-US', num_format).format(row.win_lose)}
                                <i className='fas fa-external-link-square-alt text-primary ml-1'></i>
                            </a>
                        </b>
                    ) : (
                        new Intl.NumberFormat('en-US', num_format).format(row.win_lose)
                    );

                    return val;
                },
                headerStyle: () => 
                {
                    return { width: '150px' };
                },
            },
            {
                text: `Deducts (${t('global.currency.usd')})`,
                dataField: 'deducts',
                formatter: (cell, row, rowIndex) => {
                    // Check if user has permission and deducts is not zero
                    let val = permission.includes('agent_payout_details') && (row.deducts ?? 0) > 0 ? (
                        <b>
                            <a href='/#' onClick={(event) => this.props.deductDetailsHandler(event, row.aid, this.props.data.filterInput.confirm_date, null)}>
                                {new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(row.deducts ?? 0)}
                                <i className='fas fa-external-link-square-alt text-primary ml-1'></i>
                            </a>
                        </b>
                    ) : (
                        new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(row.deducts ?? 0)
                    );

                    return val;
                },
                headerStyle: () => {
                    return { width: '150px' };
                },
            },
            {
                text: t('agent-payout.payout-usd'),
                dataField: 'total_payout',
                sort: true,
                onSort: this.onSort,
                headerStyle: () => ({ width: '150px' }),
                formatter: (cell, row) => {
                    const nf = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

                    // pull values from API row (fallbacks keep UI stable if any are missing)
                    const winLose = Number(row.win_lose ?? 0);
                    const deducts = Number(row.deducts ?? 0);
                    const pct     = Number(row.percentage ?? 0);

                    // recompute for clarity (matches what backend sends as total_payout)
                    const base    = winLose - deducts;            // final amount before % 
                    const total   = (base * pct) / 100;

                    return (
                    <div>
                        <b>{nf.format(total)}</b><br />
                        <small>
                        ({nf.format(winLose)} - {nf.format(deducts)}) * {pct}%
                        </small>
                    </div>
                    );
                },
                }
,
            
            {
                text: `${t('agent-payout.downline-agent-payout')} (${t('global.currency.usd')})`,
                dataField: 'downline_agent_payout',
                formatter: (cell, row, rowIndex) => 
                    {
                        let val = permission.includes(
                            'agent_payout_details'
                        ) ? (
                            <b>
                                <a href='/#' onClick={(event) => this.props.downlineAgentPayoutDetailsHandler(event, row.aid, this.props.data.filterInput.confirm_date, null)}>
                                    {new Intl.NumberFormat('en-US', num_format).format(row.downline_agent_payout)}
                                    <i className='fas fa-external-link-square-alt text-primary ml-1'></i>
                                </a>
                            </b>
                        ) : (
                            new Intl.NumberFormat('en-US', num_format).format(row.downline_agent_payout)
                        );
    
                        return val;
                    },
                headerStyle: () => {
                    return { width: '150px' };
                },
            },            
            {
                text: `${t('agent-payout.payout')}`,
                dataField: 'payout_base_currency',
                formatter: (cell, row, rowIndex) => 
                {
                    const formattedPayout = new Intl.NumberFormat('en-US', num_format).format(row.payout_base_currency);
                    const exchangeRateText = `(${new Intl.NumberFormat("en-US", num_format).format(row.downline_member_payout)} + ${row.downline_agent_payout}) * ${row.exchange_rate}`;

                    return (
                        <div>
                            <b>{formattedPayout}</b><br />
                            <small>{exchangeRateText}</small>
                        </div>
                    );                
                },
                headerStyle: () => 
                {
                    return { width: '150px' };
                },
            },
            {
                text: `${t('agent-payout.net-payout')}`,
                dataField: 'payout_base_currency',
                formatter: (cell, row, rowIndex, extraData) => 
                {
                    let val = permission.includes('agent_payout_submit')
                        ?
                        (
                            (Number(row.payout_base_currency) !== 0)
                                ?
                                (
                                    <NumberInput
                                        id={`payout_tbg_${row.aid}`}
                                        name={`payout_tbg_${row.aid}`}
                                        // min={0.1}
                                        value={extraData[`payout_tbg_${row.aid}`] || ''}
                                        onKeyPress={(evt) => (evt.key === 'e' && evt.preventDefault())}
                                        onChange={(event) => this.props.onInputChange(event, this.props.tabName, 'formInput')}
                                        className='form-control filter-input'
                                        required
                                    />
                                )
                                :
                                (
                                    new Intl.NumberFormat('en-US', num_format).format(row.payout_base_currency)
                                )
                        )
                        :
                        (
                            new Intl.NumberFormat('en-US', num_format).format(row.payout_base_currency)
                        );
                    return val;
                },
                headerStyle: () => 
                {
                    return { width: '150px' };
                },
                formatExtraData: this.props.data.formInput
            },
        ];

        return (
            <Auxiliary>
                <ValidationError
                    // formName='agent_payout_form'
                    touched={this.props.touched}
                    message={this.props.errMsg}
                />
                <div className='row row-sm'>
                    <div className='col-xl-12'>
                        <div className='card card-body card-primary'>
                            <div className=''>
                                {this.props.data.loading ? (
                                    <Skeleton count={2} />
                                ) : (
                                    <div method='post' id='filter_form' className={`form-horizontal filter-function row ${this.state.showCard ? 'open' : 'close'} filter-wrapper-2`}>
                                        <div className='col-md-4 col-6'>
                                            <div className='form-group'>
                                                <label className='font-weight-bolder'>{t('agent-payout.date')}</label>
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">
                                                        <i className="fas fa-calendar-check"></i>
                                                    </span>
                                                    <DatePicker
                                                        id="date"
                                                        name="date"
                                                        className="form-control filter-input"
                                                        wrapperClassName="wrapperDatePicker"
                                                        selected={this.props.data.filterInput.date_str}
                                                        onChange={this.props.handleMonthPickerChange}
                                                        popperContainer={DatePickerContainer}
                                                        dateFormat="MM/yyyy"
                                                        autoComplete="off"
                                                        showMonthYearPicker
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-4 col-6'>
                                            <div className='form-group'>
                                                <label className='font-weight-bolder'>
                                                    {t('agent-payout.agent')}
                                                </label>
                                                <StringInput
                                                    id='username'
                                                    name='username'
                                                    value={this.props.data.filterInput.username}
                                                    onChange={(event) => this.props.onInputChange(event, this.props.tabName, 'filterInput')}
                                                    className='form-control filter-input'
                                                    onSearchPress={(evt) => evt.key === 'Enter' && this.props.refreshHandler(this.props.tabName)}
                                                />
                                            </div>
                                        </div>

                                        <div className='col mt-auto'>
                                            <div className='d-flex'>
                                                {permission.includes('agent_payout_submit') && (
                                                    <Button
                                                        typeButton='submit'
                                                        classValue='btn btn-warning'
                                                        idValue='submit'
                                                        buttonName={t('agent-payout.submit-payout')}
                                                        formValue='agent_payout_form'
                                                    />
                                                )}
                                                &nbsp;
                                                <Button
                                                    typeButton='button'
                                                    classValue='btn btn-blue'
                                                    idValue='filter'
                                                    buttonName={t('global.filter')}
                                                    clicked={() => this.props.refreshHandler(this.props.tabName)}
                                                />
                                                &nbsp;
                                                <Button
                                                    typeButton='button'
                                                    classValue='btn btn-secondary'
                                                    idValue='reset'
                                                    buttonName={t('global.reset')}
                                                    clicked={() => this.props.clearHandler(this.props.tabName)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className='show-btn' onClick={() => this.toggleCard()}>
                                {this.state.showCard ? (
                                    <AiFillMinusCircle />
                                ) : (
                                    <AiFillPlusCircle />
                                )}
                            </div>
                        </div>
                    </div>

                    {/* <div className='col-xl-12'>
                        <div className='card'>
                            <div className='card-header pb-0'>
                                <div className='card-title mb-1'>
                                    <h4 className='card-title mg-b-0'>
                                        {t('agent-payout.company-profit')}
                                    </h4>
                                    {(this.props.data.loading)
                                    ?
                                        <Skeleton width={50} count={2} />
                                    :
                                    this.props.data.exchangeRate && 
                                        Object.keys(this.props.data.exchangeRate).map((item, i) => 
                                        {
                                            return (
                                                <><small style={{color: '#8B0000'}}><b>*{this.props.data.exchangeRate[item]}</b></small><br/></>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            
                            <div className='card-body'>
                                <div className='table-responsive table-hover datatable'>
                                    {(this.props.data.loading)
                                    ?
                                        <Skeleton count={3} />
                                    :
                                        <DataTable
                                            keyField='aid'
                                            data={this.props.data.cpData}
                                            columns={cpColumn}
                                            classValue='dataTable table-bordered text-justify text-center'
                                            loading={this.props.data.loading}
                                            hideSearchBar={true}
                                            hideSizePerPage={true}
                                            hideTotalRecords={true}
                                            hidePagination={true}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div> */}

                    <div className='col-xl-12'>
                        <div className='card'>
                            <div className='card-header pb-0'>
                                <div className='card-title mb-1'>
                                    <h4 className='card-title mg-b-0'>
                                        {t('agent-payout.agent-payout')}
                                    </h4>
                                    <br/>
                                    {this.props.data.loading ? (
                                        <Skeleton width={50} count={2} />
                                    ) : (
                                        <>
                                            {this.props.data.exchangeRate &&
                                                Object.keys(this.props.data.exchangeRate).map((item, i) => (
                                                    <React.Fragment key={i}>
                                                        <small style={{ color: '#8B0000' }}><b>*{this.props.data.exchangeRate[item]}</b></small><br/>
                                                    </React.Fragment>
                                                ))}
                                            <small style={{ color: '#8B0000' }}><b>*{t('agent-payout.downline-agent-commission')} = 10%</b></small><br/>
                                        </>
                                    )}
                                </div>
                            </div>
                            <div className='card-body'>
                                <div className='table-responsive table-hover datatable'>
                                    <form
                                        method='post'
                                        id='agent_payout_form'
                                        className='form-horizontal filter-function'
                                        onSubmit={(event) => this.props.submitHandler(event, this.props.tabName)}
                                        noValidate
                                    >
                                        <DataTable
                                            keyField='agent'
                                            data={this.props.data.data}
                                            columns={columns}
                                            activePage={this.props.data.activePage}
                                            limit={this.props.data.limit}
                                            totalItems={this.props.data.totalRecords}
                                            paginationHandler={(val) => this.props.datatablesChangeHandler(val, this.props.tabName, 'activePage')}
                                            sizePerPageHandler={(val) => this.props.datatablesChangeHandler(val, this.props.tabName, 'limit')}
                                            searchChangeHandler={(val) => this.props.datatablesChangeHandler(val, this.props.tabName, 'searchValue')}
                                            searchValue={this.props.data.searchValue}
                                            classValue='dataTable table-bordered text-justify text-center'
                                            loading={this.props.data.loading}
                                            hideSearchBar={true}
                                            // expandRow={expandRow}
                                        />
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

export default withNamespaces('translation')(AgentPayoutListing);